import { id } from "./id";

type StrategicAxis = {
  uuid: string;
  color: string;
  name: string;
  code: string;
  weight: number;
  adequacyPossibilities: { [key: string]: string };
};

const strategicAxis: StrategicAxis = {
  uuid: id,
  color: "#000",
  name: "",
  code: "",
  weight: 1,
  adequacyPossibilities: {
    "-2": "",
    "-1": "",
    "0": "",
    "1": "",
    "2": "",
  },
};

export type { StrategicAxis };

export { strategicAxis };
